module.exports = __webpack_public_path__ + "img/logo-daxx-new.39b9d224.svg";